<template>
  <span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 16 14"
      fill="none"
      class="tw-mt-[2px]"
    >
      <path
        d="M14.5579 1.20027C13.7937 0.437979 12.7587 0.00930549 11.6793 0.00798788C10.5999 0.00667026 9.56395 0.432816 8.79789 1.19324L7.8782 2.04753L6.95781 1.19043C6.19193 0.426695 5.15404 -0.0015124 4.07244 4.01388e-06C2.99085 0.00152043 1.95416 0.432637 1.19043 1.19851C0.426695 1.96439 -0.00151239 3.00228 4.01379e-06 4.08388C0.00152041 5.16547 0.432636 6.20216 1.19851 6.96589L7.48093 13.3404C7.53327 13.3936 7.59566 13.4358 7.66447 13.4646C7.73327 13.4934 7.80712 13.5082 7.88171 13.5082C7.95631 13.5082 8.03016 13.4934 8.09896 13.4646C8.16777 13.4358 8.23016 13.3936 8.2825 13.3404L14.5579 6.96589C15.3222 6.20117 15.7515 5.16425 15.7515 4.08308C15.7515 3.00192 15.3222 1.965 14.5579 1.20027ZM13.7598 6.17558L7.8782 12.1409L1.99304 6.16996C1.4392 5.61611 1.12805 4.86493 1.12805 4.08168C1.12805 3.29842 1.4392 2.54724 1.99304 1.99339C2.54689 1.43955 3.29807 1.1284 4.08132 1.1284C4.86458 1.1284 5.61576 1.43955 6.1696 1.99339L6.18367 2.00746L7.495 3.22738C7.59909 3.32425 7.736 3.3781 7.8782 3.3781C8.02039 3.3781 8.15731 3.32425 8.2614 3.22738L9.57273 2.00746L9.58679 1.99339C10.141 1.43992 10.8924 1.12928 11.6757 1.12981C12.4589 1.13033 13.2099 1.44199 13.7634 1.99621C14.3168 2.55043 14.6275 3.30181 14.6269 4.08507C14.6264 4.86833 14.3148 5.6193 13.7605 6.17277L13.7598 6.17558Z"
        :fill="strokeColor"
      />
    </svg>
  </span>
</template>
<script>
export default {
  name: 'HeartStraight',
  props: {
    strokeColor: {
      type: String,
      default: '#6B7280',
    },
  },
};
</script>
